import { useDispatch, useSelector } from "react-redux";
import { Snackbar, Alert, Link } from "@mui/material";

import { setChunkReloadFailed } from 'store/Shared.Slice';

const ChunkReloadNotice = () => {
    const dispatch = useDispatch();
    const { chunkReloadFailed } = useSelector(state => state.sharedState);

    return (
        <Snackbar
            open={chunkReloadFailed}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        >
            <Alert
                severity="info"
                variant="filled"
                onClose={() => dispatch(setChunkReloadFailed(false))}
            >
                This page couldn't load.{' '}
                <Link
                    component="button"
                    color="inherit"
                    underline="always"
                    onClick={() => window.location.reload()}
                >
                    Click here to refresh
                </Link>
            </Alert>
        </Snackbar>
    )
}

export default ChunkReloadNotice;
